export default __webpack_public_path__ + "static/media/scholarship.df0c16b8.png";